import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import { ConsumptionRequest } from '@core/domain/model/consumption/consumption-request.model';
import { PaginatorInput } from '@shared/components/paginator/models/paginator-input.model';
import { SortEvent } from '@shared/components/table/sort/model/sort.model';
import { ConsumptionRequestListFilter } from '@pages/my-consumption/consumption/ui/consumption-request-list/model/consumption-request-list.filter';
import {
  AcsConsumption,
  AcsConsumptionGraphType,
  ClimateConsumption,
  ClimateConsumptionGraphType,
  ConsumptionInvoicesFilter,
  HousingModel,
  RoomModel,
  ReportModel,
} from '@core/domain/model/consumption-invoices/consumption-invoices.model';

export const consumptionInvoicesActions = {
  fetchRequestList: createAction('[Consumptions Invoices Request List] Fetch Request List'),
  setRequestList: createAction('[Consumptions Invoices Request List API] Set Request List', props<{ data: ConsumptionRequest[] }>()),
  sortRequestList: createAction('[Consumptions Invoices Request List] Sort Request List', props<{ sort: SortEvent }>()),
  pageRequestList: createAction('[Consumptions Invoices Request List] Page Request List', props<{ page: PaginatorInput }>()),
  filterRequestList: createAction(
    '[Consumptions Invoices Request List] Filter Request List',
    props<{ filter: ConsumptionRequestListFilter }>()
  ),
  setRequestListError: createAction('[Consumptions Invoices Request List API] Set Request List Error', props<{ error: string }>()),
  initTab: createAction('[Consumptions Invoices] Initialize which tab to show'),
  changeTab: createAction('[Consumptions Invoices] Change tab', props<{ index: number }>()),
  initFilter: createAction('[Consumptions Invoices] Set initial filters', props<{ filter: ConsumptionInvoicesFilter }>()),
  setAcsGraphType: createAction(
    '[Consumptions Acs] Set Accumulated Graph Type',
    props<{
      graphType: AcsConsumptionGraphType;
    }>()
  ),
  setAcsFilter: createAction('[Consumptions Acs] Set filter', props<{ filter: ConsumptionInvoicesFilter | null }>()),
  fetchAcsData: createAction('[Consumptions Acs] Fetch accumulated'),
  downloadAcsExcel: createAction('[Consumptions Acs] Download accumulated excel'),
  setAcsData: createAction(
    '[Consumptions Acs API] Set acs data',
    props<{
      previousData: AcsConsumption[] | null;
      currentData: AcsConsumption[] | null;
    }>()
  ),
  setAcsError: createAction('[Consumptions Acs API] Set acs error', props<{ error: string }>()),
  setClimateGraphType: createAction(
    '[Consumptions Climate] Set Climate Graph Type',
    props<{
      graphType: ClimateConsumptionGraphType;
    }>()
  ),
  setClimateFilter: createAction('[Consumptions Climate] Set filter', props<{ filter: ConsumptionInvoicesFilter | null }>()),
  fetchClimateData: createAction('[Consumptions Climate] Fetch climate'),
  downloadClimateExcel: createAction('[Consumptions Climate] Download climate excel'),
  setClimateData: createAction(
    '[Consumptions Climate API] Set climate data',
    props<{
      previousData: ClimateConsumption[] | null;
      currentData: ClimateConsumption[] | null;
    }>()
  ),
  setClimateError: createAction('[Consumptions Climate API] Set climate error', props<{ error: string }>()),
};

export const RehabActions = createActionGroup({
  source: 'Rehabilitation',
  events: {
    fetchHousingClimate: emptyProps(),
    setHousingClimate: props<{ data: HousingModel[] | null }>(),
    errorHousingClimate: props<{ error: string }>(),
    fetchRoomsClimate: emptyProps(),
    setRoomsClimate: props<{ data: RoomModel[] | null }>(),
    errorRoomsClimate: props<{ error: string }>(),
    fetchHousingAcs: emptyProps(),
    setHousingAcs: props<{ data: HousingModel[] | null }>(),
    errorHousingAcs: props<{ error: string }>(),
    fetchRoomsAcs: emptyProps(),
    setRoomsAcs: props<{ data: RoomModel[] | null }>(),
    errorRoomsAcs: props<{ error: string }>(),
  },
});

export const ConsumptionInvoicesInformesActions = createActionGroup({
  source: 'Consumption Invoices',
  events: {
    fetchInformesUser: emptyProps(),
    setInformesUser: props<{ data: ReportModel[] }>(),
    errorInformesUser: props<{ error: string }>(),
  },
});
